'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="#FF4473" fillRule="evenodd" d="M15.329 3.586a2 2 0 0 1 2.828 0l2.828 2.828a2 2 0 0 1 0 2.829l-12.02 12.02a1 1 0 0 1-.711.293l-4.257-.015A1 1 0 0 1 3 20.539l.015-4.228a1 1 0 0 1 .293-.703zM5.013 16.729l-.01 2.816 2.842.01L19.57 7.828 16.743 5z" clipRule="evenodd" /><path fill="#FF4473" d="m13.707 6.586 4.243 4.242-.707.708L13 7.293z" /><path fill="#FF4473" d="m5 16 8.5-8.5 4 3.5L9 20H5z" /></svg>;
const IconPublishActive = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconPublishActive;